export const getUserDataFromState = (state) => state.user;
export const getWordsGroupAndPageFromState = (state) => state.wordsGroupAndPage;
export const getSettingsFromState = (state) => state.settings;
